import { useEffect } from "react";
import { useViewerCurrencyStore } from "@/store/viewerCurrencyStore";

/** Kicks off exchange-rate loading + IP-based currency auto-detection once per app load. Renders nothing. */
export default function ViewerCurrencyInit() {
  const init = useViewerCurrencyStore((s) => s.init);
  useEffect(() => {
    void init();
  }, [init]);
  return null;
}
